export default "__VITE_ASSET__BLhYDbAU__"